export default __webpack_public_path__ + "static/media/desc.820185e3.svg";